import React from 'react';
import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@fluentui/react-components';
import { DismissRegular, ErrorCircleRegular } from '@fluentui/react-icons';

interface ErrorDialogProps {
  isOpen: boolean;
  onClose: () => void;
  message?: string;
}

const ErrorDialog: React.FC<ErrorDialogProps> = ({
  isOpen,
  onClose,
  message = 'Ett fel uppstod. Vänligen försök igen.',
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={(_, data) => !data.open && onClose()}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle
            action={
              <Button
                appearance="subtle"
                icon={<DismissRegular />}
                onClick={onClose}
              />
            }
          >
            Fel
          </DialogTitle>
          <DialogContent>
            <div className="flex items-center gap-3">
              <ErrorCircleRegular className="text-red-600 w-6 h-6" />
              <p className="text-sm">{message}</p>
            </div>
          </DialogContent>
          <DialogActions>
            <Button appearance="primary" onClick={onClose}>
              OK
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default ErrorDialog;
